import React from 'react';
import TextField from '@atlassian/jira-issue-create-commons/src/ui/text-field/index.tsx';
import { SUMMARY_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { TextFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import type { FieldTypeConfig } from '../types.tsx';
import { textFieldWriter } from '../writers/index.tsx';

export const SummaryFieldTypeConfig: FieldTypeConfig<string> = {
	type: SUMMARY_TYPE,
	Component: TextField,
	placeholder: <TextFieldPlaceholder />,
	writer: textFieldWriter,
};
